// Mirrors backend/fieldrules.py so the signer sees exactly what the server will require.
const SIGNER = ["patient", "poa"];
const MAXLEN = { textarea: 2000, name: 120, email: 254, phone: 32, number: 32 };
const CHECK = {
  number: [/^-?\d{1,12}(\.\d{1,4})?$/, "must be a number"],
  email: [/^[^@\s]{1,64}@[^@\s]+\.[A-Za-z]{2,}$/, "must be a valid email"],
  phone: [/^[\d\s()+.-]+$/, "must be a valid phone number"],
};
const empty = (v) => v === null || v === undefined || v === false || (typeof v === "string" && v.trim() === "");

function typeError(f, v) {
  if (empty(v)) return null;
  const s = String(v).trim();
  if (!["signature", "initials"].includes(f.type) && s.length > (MAXLEN[f.type] || 500)) return "is too long";
  const c = CHECK[f.type];
  if (c && !c[0].test(s)) return c[1];
  if (f.type === "phone") { const n = s.replace(/\D/g, "").length; if (n < 10 || n > 15) return CHECK.phone[1]; }
  if (f.type === "choice" && !(f.options || []).includes(s)) return "must be one of the listed options";
  return null;
}

export function missingFields(fields, vals) {
  const sig = fields.filter((f) => SIGNER.includes(f.role));
  const poaSigned = sig.some((f) => f.role === "poa" && ["signature", "initials"].includes(f.type) && !empty(vals[f.id]));
  const out = [];
  const groups = {};
  sig.forEach((f) => {
    const v = vals[f.id];
    const err = typeError(f, v);
    if (err) out.push(`${f.label} ${err}`);
    if (f.group) (groups[f.group] = groups[f.group] || []).push(f);
    else if (f.required && empty(v) && (f.role !== "poa" || poaSigned)) out.push(f.label);
  });
  Object.values(groups).forEach((items) => {
    if (items.some((x) => x.required) && !items.some((x) => !empty(vals[x.id]))) out.push(`One of: ${items.map((x) => x.label).join(" / ")}`);
  });
  return out;
}
